import {PairVariant, WeightVariant} from './pair-variant';
import {GetSafeValue} from '../../utils/get-safe-value';
import {StringFieldUtil} from '../../utils/string-field-util';
import {StringUtils} from '../../utils/string-utils';
import {SharedPreference} from '../../shared-preference/shared-perference';
import {CurrencyUtil} from "../../utils/currency-converter";

export class Item {
  private _id: string;
  private _title: Map<string, string>;
  private _rating: string;
  private _reviewCounter: number;
  private _brand: string;
  private _category: string;
  private _hsCode: string;
  private _keywords: string[];
  private _collection: string;
  private _description: Map<string, any>;
  private _documentPath: string;
  private _modifiedAt: string;
  private _isEnable: boolean;
  private _saleType: string;
  private _barcodes: string[];
  private _itemSpecialExpirationDate: string;
  private _variation: Map<string, ItemVariation>;
  private _imageUrls: string[];
  private _relatedItems: string[];
  private _variationOrder: VariationOrder;
  private _storeId: string;
  private _type: string;
  private _location: string;
  private _startsDate: string;
  private _endsDate: string;
  private _ranking: number;
  private _isApproved: string;
  private _modifier: string;
  private _tag : string;

  constructor() {
    this.title = new Map();
    this.description = new Map();
    this.keywords = [];
    this.collection = undefined;
    this.modifiedAt = StringUtils.getDateLocal(StringUtils.getDateUTC(new Date()));
    this.variation = new Map();
    this.barcodes = [];
    this.location = "";
    this.startsDate = "";
    this.variationOrder = new VariationOrder();
    this.ranking = 0;
  }

  fromJson(id:string, data: any){
    this.id = GetSafeValue.getSafeValueAsString(id, null);
    this.storeId = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.storeId], null);
    this.documentPath = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.documentPath], null);
    this.rating = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.rating], null);
    this.reviewCounter = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.reviewCounter], null);
    this.brand = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.brand], null);
    this.category = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.category], null);
    this.hsCode = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.hsCode], null);
    this.title = GetSafeValue.getSafeValueAsMap(data[StringFieldUtil.title], {'en': '', 'kh': ''});
    this.description = GetSafeValue.getSafeValueAsMap(data[StringFieldUtil.description], {'en': "", 'kh': "", 'imageUrls': []});
    this.keywords = GetSafeValue.getSafeValueAsList(data[StringFieldUtil.keywords], [], []);
    this.collection = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.collection], null);
    this.isEnable = GetSafeValue.getSafeValueAsBoolean(data[StringFieldUtil.isEnable], null);
    this.modifiedAt = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.modifiedAt], null);
    this.saleType = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.saleType], null);
    this.barcodes = GetSafeValue.getSafeValueAsList(data[StringFieldUtil.barcodes], [], []);
    this.relatedItems = GetSafeValue.getSafeValueAsList(data[StringFieldUtil.relatedItems], [], []);
    this.itemSpecialExpirationDate = GetSafeValue.getSafeValueAsString(
      StringUtils.getDateFormat(data[StringFieldUtil.itemSpecialExpirationDate], 'yyyy-MM-dd'), null);
    this.setMapItemVariation(data);
    let sortItem : VariationOrder = new VariationOrder();
    data['variationOrder'] ? sortItem .fromJson(data['variationOrder']) : new VariationOrder();
    this.variationOrder = sortItem ;
    this.type = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.type], '');
    this.location = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.location], '');
    this.startsDate = GetSafeValue.getSafeValueAsString(
      StringUtils.getDateFormat(data[StringFieldUtil.startsDate], 'yyyy-MM-dd hh:mm a'), null);
    this.endsDate = GetSafeValue.getSafeValueAsString(
      StringUtils.getDateFormat(data[StringFieldUtil.endsDate], 'yyyy-MM-dd hh:mm a'), null);
    this.ranking = GetSafeValue.getSafeValueAsNumber(data['ranking'], 0);
    this.isApproved =  GetSafeValue.getSafeValueAsString(data[StringFieldUtil.isApproved], null);
    this.modifier =  GetSafeValue.getSafeValueAsString(data[StringFieldUtil.modifier], null);
    this.tag = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.tag], null);
  }

  setMapItemVariation(data: Item) {
    if (data[StringFieldUtil.variation]) {
      StringUtils.objToStrMap(data[StringFieldUtil.variation]).forEach((v, k) => {
        let itemVariation = new ItemVariation();
        itemVariation.fromJson(k, v);
        this.variation.set(k, itemVariation);
      });
    }
  }

  static cloneItem(data: Item) {
    let item = Object.assign(new Item(), data);
    let variantOrder = VariationOrder.clone(item.variationOrder);
    let variation = Item.cloneMapItemVariant(data);
    item.variationOrder = variantOrder;
    item.variation = variation;
    item.keywords = Object.assign([], data.keywords);
    return item;
  }

  static cloneMapItemVariant(data: Item) {
    let variation: Map<string, ItemVariation> = new Map();
    data.variation.forEach((v, k) => {
      let itemVariant = ItemVariation.clone(v);
      if(!k.includes('undefined')){
        variation.set(k, itemVariant);
      }
    });

    return variation;
  }


  get tag(): string {
    return this._tag;
  }

  set tag(value: string) {
    this._tag = value;
  }

  get location(): string {
    return this._location;
  }

  set location(value: string) {
    this._location = value;
  }

  get startsDate(): string {
    return this._startsDate;
  }

  set startsDate(value: string) {
    this._startsDate = value;
  }

  get endsDate(): string {
    return this._endsDate;
  }

  set endsDate(value: string) {
    this._endsDate = value;
  }

  get barcodes(): string[] {
    return this._barcodes;
  }

  set barcodes(value: string[]) {
    this._barcodes = value;
  }

  get imageUrls(): string[] {
    return this._imageUrls;
  }

  set imageUrls(value: string[]) {
    this._imageUrls = value;
  }

  get relatedItems(): string[] {
    return this._relatedItems;
  }

  set relatedItems(value: string[]) {
    this._relatedItems = value;
  }

  get id(): string {
    return this._id;
  }

  set id(value: string) {
    this._id = value;
  }

  get documentPath(): string {
    return this._documentPath;
  }

  set documentPath(value: string) {
    this._documentPath = value;
  }

  get rating(): string {
    return this._rating;
  }

  set rating(value: string) {
    this._rating = value;
  }

  get reviewCounter(): number {
    return this._reviewCounter;
  }

  set reviewCounter(value: number) {
    this._reviewCounter = value;
  }

  get brand(): string {
    return this._brand;
  }

  set brand(value: string) {
    this._brand = value;
  }

  get saleType(): string {
    return this._saleType;
  }

  set saleType(value: string) {
    this._saleType = value;
  }

  get category(): string {
    return this._category;
  }

  set category(value: string) {
    this._category = value;
  }

  get hsCode(): string {
    return this._hsCode;
  }

  set hsCode(value: string) {
    this._hsCode = value;
  }

  get title(): Map<string, string> {
    return this._title;
  }

  set title(value: Map<string, string>) {
    this._title = value;
  }

  get description(): Map<string, any> {
    return this._description;
  }

  set description(value: Map<string, any>) {
    this._description = value;
  }

  get keywords(): string[] {
    return this._keywords;
  }

  set keywords(value: string[]) {
    this._keywords = value;
  }

  get collection(): string {
    return this._collection;
  }

  set collection(value: string) {
    this._collection = value;
  }

  get isEnable(): boolean {
    return this._isEnable;
  }

  set isEnable(value: boolean) {
    this._isEnable = value;
  }


  get variation(): Map<string, ItemVariation> {
    return this._variation;
  }

  get modifiedAt(): string {
    return this._modifiedAt;
  }

  set modifiedAt(value: string) {
    this._modifiedAt = value;
  }

  set variation(value: Map<string, ItemVariation>) {
    this._variation = value;
  }

  get itemSpecialExpirationDate(): string {
    return this._itemSpecialExpirationDate;
  }

  set itemSpecialExpirationDate(value: string) {
    this._itemSpecialExpirationDate = value;
  }


  get variationOrder(): VariationOrder {
    return this._variationOrder;
  }

  set variationOrder(value: VariationOrder) {
    this._variationOrder = value;
  }


  get storeId(): string {
    return this._storeId;
  }

  set storeId(value: string) {
    this._storeId = value;
  }


  get type(): string {
    return this._type;
  }

  set type(value: string) {
    this._type = value;
  }


  get ranking(): number {
    return this._ranking;
  }

  set ranking(value: number) {
    this._ranking = value;
  }

  get isApproved(): string {
    return this._isApproved;
  }

  set isApproved(value: string) {
    this._isApproved = value;
  }

  get modifier(): string {
    return this._modifier;
  }

  set modifier(value: string) {
    this._modifier = value;
  }

  toMap(isImport: boolean = false) {
    let itemVariation = isImport ? this.setMapToObjectItemVariationApi(this.saleType) : this.setMapToObjectItemVariation();
    let barcodes = new Set(this.barcodes);
    let relatedItems = new Set(this.relatedItems);
    return {
      'description': {
        'en': this.description['en'] === undefined ? '' : this.description['en'],
        'kh': this.description['kh'] === undefined ? '' : this.description['kh'],
        'imageUrls': this.description['imageUrls'] === undefined ? '' : this.description['imageUrls'],
      },
      'title': {
        'en': this.title['en'],
        'kh': this.title['kh']
      },
      'id': this.id,
      'barcodes': Array.from(barcodes),
      'relatedItems': Array.from(relatedItems),
      'brand': this.brand || null,
      'rating': this.rating || null,
      'reviewCounter': this.reviewCounter || null,
      'category': this.category || null,
      'hsCode': this.hsCode,
      'keywords': this.keywords || [],
      'collection': this.collection || null,
      'saleType': this.saleType || null,
      'isEnable': this.isEnable == null || this.isEnable == undefined ? false : this.isEnable,
      'modifiedAt': this.modifiedAt || null,
      'itemSpecialExpirationDate': this.itemSpecialExpirationDate || null,
      'variation': itemVariation,
      'variationOrder' : this.variationOrder.toMap(),
      'storeId': this.storeId,
      'type': this.type ? this.type : null,
      'location': this.location ? this.location : null,
      'startsDate': this.startsDate ? this.startsDate : null,
      'endsDate': this.endsDate ? this.endsDate : null,
      'ranking': this.ranking || null,
      "isApproved": this.isApproved || null,
      "modifier": SharedPreference.getUser().uid || null,
      "tag" : this.tag
    };
  }

  toMapApi() {
    let itemVariation = this.setMapToObjectItemVariationApi(this.saleType);
    let relatedItems = new Set(this.relatedItems);
    return {
      'description': {
        'en': this.description['en'] === undefined ? '' : this.description['en'],
        'kh': this.description['kh'] === undefined ? '' : this.description['kh'],
        'imageUrls': this.description['imageUrls'] === undefined ? '' : this.description['imageUrls'],
      },
      'title': {
        'en': this.title['en'],
        'kh': this.title['kh']
      },
      'brand': this.brand,
      'rating': this.rating,
      'reviewCounter': this.reviewCounter,
      'category': this.category,
      'hsCode': this.hsCode,
      'keywords': this.keywords,
      'collection': this.collection,
      'relatedItems': Array.from(relatedItems),
      'saleType': this.saleType,
      'isEnable': !this.isEnable ? false : this.isEnable,
      'itemSpecialExpirationDate': this.itemSpecialExpirationDate,
      'variation': itemVariation,
      'variationOrder' : this.variationOrder.toMap(),
      'storeId': this.storeId,
      'type': this.type ? this.type : "normal",
      'ranking': this.ranking,
      "isApproved": this.isApproved,
      "modifier": SharedPreference.getUser().uid,
      "tag" : this.tag,
      'location': this.location ? this.location : null,
      'startsDate': this.startsDate ? this.startsDate : null,
      'endsDate': this.endsDate ? this.endsDate : null,
    };
  }

  setMapToObjectItemVariation() {
    let mapVariation: Map<string, any> = new Map();

    this.variation.forEach((v, k) => {
      mapVariation.set(k, v.toMap());
    });

    return StringUtils.strMapToObj(mapVariation);
  }

  setMapToObjectItemVariationApi(saleType) {
    let mapVariation: Map<string, any> = new Map();

    this.variation.forEach((v, k) => {
      mapVariation.set(k, v.toMapApi(saleType));
    });

    return StringUtils.strMapToObj(mapVariation);
  }
}

export class ItemVariation{
  private _id: string;
  private _barcode: string;
  private _originalPrice: number;
  private _discount: number;
  private _imageUrls: string[];
  private _salePrice: number;
  private _qtyPerCase: PairVariant;
  private _size: PairVariant;
  private _weight: WeightVariant;
  private _color: PairVariant;
  private _type: PairVariant;
  private _isEnable: boolean;
  private _availableQty: number;
  private _bufferQty: number;
  private _unitCost: number;
  private _noStockLimit: boolean;
  private _compositions: any[];

  constructor(){
    this.color = new PairVariant();
    this.size = new PairVariant();
    this.weight = new WeightVariant();
    this.qtyPerCase = new PairVariant();
    this.type = new PairVariant();
  }

  fromJson(id:string, data: ItemVariation){
    this.id = GetSafeValue.getSafeValueAsString(id, undefined);
    this.barcode = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.barcode], undefined);
    this._originalPrice = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.originalPrice], 0);
    this._salePrice = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.salePrice], 0);
    this.availableQty = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.availableQty], 0);
    this.bufferQty = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.bufferQty], 0);
    this._unitCost = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.unitCost], 0);
    this.discount = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.discount], null);
    this.imageUrls = GetSafeValue.getSafeValueAsList(data[StringFieldUtil.imageUrls], [], []);
    this.isEnable = GetSafeValue.getSafeValueAsBoolean(data[StringFieldUtil.isEnable], false);
    this.compositions = GetSafeValue.getSafeValueAsList(data[StringFieldUtil.compositions], [], []);
    this.noStockLimit = GetSafeValue.getSafeValueAsBoolean(data[StringFieldUtil.noStockLimit], false);
    this.sizeFromJson(data);
    this.weightFromJson(data);
    this.colorFromJson(data);
    this.qtyPerCaseFromJson(data);
    this.typeFromJson(data);
  }

  private splitStoreId(value: string) {
    let tempValue = GetSafeValue.getSafeValueAsString(value, undefined);
    if(!tempValue){
      return tempValue;
    }
    if (tempValue.includes(StringUtils.generateBarcode(''))) {
      return tempValue.split(StringUtils.generateBarcode(''))[1];
    }else {
      return tempValue;
    }
  }

  private sizeFromJson(data: ItemVariation) {
    if (data[StringFieldUtil.size]) {
      this.size = new PairVariant();
      let size = new PairVariant();
      size.fromJson(data[StringFieldUtil.size]);
      size.value = ['NaNkg','NaNL'].includes(size.value) ? '' : size.value;
      this.size = size;
    }
  }

  private weightFromJson(data: ItemVariation) {
    if (data[StringFieldUtil.weight]) {
      this.weight = new WeightVariant();
      let weight = new WeightVariant();
      weight.fromJson(data[StringFieldUtil.weight]);
      this.weight = weight;
    }
  }

  private colorFromJson(data: ItemVariation) {
    if (data[StringFieldUtil.color]) {
      this.color = new PairVariant();
      let color = new PairVariant();
      color.fromJson(data[StringFieldUtil.color]);
      if (color.key == null || !color.key || color.key === "" || color.key.toString().length < 4) {
        this.color.key = "";
      } else {
        this.color.key = color.key.substring(4);
      }
      this.color.value = color.value;
    }
  }

  private qtyPerCaseFromJson(data: ItemVariation) {
    if (data[StringFieldUtil.qtyPerCase]) {
      this.qtyPerCase = new PairVariant();
      let qtyPerCase = new PairVariant();
      qtyPerCase.fromJson(data[StringFieldUtil.qtyPerCase]);
      this.qtyPerCase = qtyPerCase;
    }
  }

  private typeFromJson(data: ItemVariation) {
    if (data[StringFieldUtil.type]) {
      this.type = new PairVariant();
      let type = new PairVariant();
      type.fromJson(data[StringFieldUtil.type]);
      this.type = type;
    }
  }

  static clone(data: ItemVariation) {
    let itemVariation = Object.assign(new ItemVariation(), data);
    itemVariation.imageUrls = Object.assign([], itemVariation.imageUrls);
    itemVariation.color = PairVariant.clone(itemVariation.color);
    itemVariation.size = PairVariant.clone(itemVariation.size);
    itemVariation.weight = WeightVariant.clone(itemVariation.weight);
    itemVariation.qtyPerCase = PairVariant.clone(itemVariation.qtyPerCase);
    itemVariation.type = PairVariant.clone(itemVariation.type);

    return itemVariation;
  }

  get availableQty(): number {
    return this._availableQty;
  }

  set availableQty(value: number) {
    this._availableQty = value;
  }

  get bufferQty(): number {
    return this._bufferQty;
  }

  set bufferQty(value: number) {
    this._bufferQty = value;
  }

  get privateUnitCost(): number {
    return this._unitCost;
  }

  set privateUnitCost(value: number) {
    this._unitCost = value;
  }

  get unitCost(): number {
    return CurrencyUtil.getValue(this._unitCost);
  }

  set unitCost(value: number) {
    this._unitCost = CurrencyUtil.setValue(value, undefined, this._unitCost);
  }

  get privateOriginalPrice(): number {
    return this._originalPrice;
  }

  set privateOriginalPrice(value: number) {
    this._originalPrice = value;
  }

  get originalPrice(): number {
    return CurrencyUtil.getValue(this._originalPrice);
  }

  set originalPrice(value: number) {
    this._originalPrice = CurrencyUtil.setValue(value, undefined, this._originalPrice);
  }

  get privateSalePrice(): number {
    return this._salePrice;
  }

  set privateSalePrice(value: number) {
    this._salePrice = value;
  }

  get salePrice(): number {
    return CurrencyUtil.getValue(this._salePrice);
  }

  set salePrice(value: number) {
    this._salePrice = CurrencyUtil.setValue(value, undefined, this._salePrice);;
  }

  get isEnable(): boolean {
    return this._isEnable;
  }

  set isEnable(value: boolean) {
    this._isEnable = value;
  }

  get id(): string {
      return this._id;
  }

  set id(value: string) {
    this._id = value;
  }

  get barcode(): string {
      return this._barcode;
  }

  set barcode(value: string) {
    this._barcode = value;
  }

  get discount(): number {
    return this._discount;
  }

  set discount(value: number) {
    this._discount = value;
  }

  get imageUrls(): string[] {
    return this._imageUrls;
  }

  set imageUrls(value: string[]) {
    this._imageUrls = value;
  }

  get qtyPerCase(): PairVariant {
    return this._qtyPerCase;
  }

  set qtyPerCase(value: PairVariant) {
    this._qtyPerCase = value;
  }

  get size(): PairVariant {
    return this._size;
  }

  set size(value: PairVariant) {
    this._size = value;
  }

  get weight(): WeightVariant {
    return this._weight;
  }

  set weight(value: WeightVariant) {
    this._weight = value;
  }

  get color(): PairVariant {
    return this._color;
  }

  set color(value: PairVariant) {
    this._color = value;
  }

  get type(): PairVariant {
    return this._type;
  }

  set type(value: PairVariant) {
    this._type = value;
  }

  get noStockLimit(): boolean {
    return this._noStockLimit;
  }

  set noStockLimit(value: boolean) {
    this._noStockLimit = value;
  }

  get compositions(): any {
    return this._compositions;
  }

  set compositions(value: any) {
    this._compositions = value;
  }

  toMap() {
    return {
      'barcode': this.barcode,
      'originalPrice': this.originalPrice,
      'discount': this.discount,
      'imageUrls': this.imageUrls,
      'salePrice': this.salePrice,
      'isEnable': this.isEnable,
      'compositions': this.compositions,
      'noStockLimit': this.noStockLimit,
      'size': {
        'key': this.size.key,
        'value': this.size.value
      },
      'weight': {
        'unit': this.weight.unit,
        'value': this.weight.value
      },
      'qtyPerCase': {
        'key': this.qtyPerCase.key,
        'value': this.qtyPerCase.value
      },
      'color': {
        'key': "0xFF" + (this.color.key ? this.color.key.trim() : ""),
        'value': this.color.value
      },
      'type': {
        'key': this.type.key ? this.type.key : "type",
        'value': this.type.value ? this.type.value : ""
      },
    };
  }

  toMapApi(saleType) {
    const isSpecialItem: boolean = [StringUtils.sales, StringUtils.promotion].includes(saleType);
    return {
      'barcode': this.barcode,
      'originalPrice': this._originalPrice,
      'discount': isSpecialItem ? this.discount || 0 : 0,
      'imageUrls': this.imageUrls,
      'salePrice': isSpecialItem ? this._salePrice : this._originalPrice,
      'availableQty': this.availableQty,
      'bufferQty': this.bufferQty,
      'unitCost': this._unitCost,
      'isEnable': this.isEnable,
      'compositions': this.compositions,
      'noStockLimit': this.noStockLimit,
      'size': {
        'key': this.size.key,
        'value': this.size.value ? this.size.value.trim() : this.size.value
      },
      'weight': {
        'unit': this.weight.unit,
        'value': this.weight.value
      },
      'qtyPerCase': {
        'key': this.qtyPerCase.key,
        'value': this.qtyPerCase.value ? this.qtyPerCase.value.trim() : this.qtyPerCase.value
      },
      'color': {
        'key': "0xFF" + (this.color.key ? this.color.key.trim() : ""),
        'value': this.color.value ? this.color.value.trim() : this.color.value
      },
      'type': {
        'key': this.type.key ? this.type.key : "type",
        'value': this.type.value ? this.type.value.trim() : ""
      },
    };
  }
}

export class VariationOrder {
  private _size: string[];
  private _qtyPerCase: string[];
  private _color: string[];
  private _type: string[];
  private _condition: string[];

  constructor() {
    this.size = [];
    this.qtyPerCase = [];
    this.color = [];
    this.type = [];
    this.condition = [];
  }

  fromJson(data: VariationOrder) {
    this.size = GetSafeValue.getSafeValueAsList(data['size'], [], []);
    this.size = this.size.filter(s => !['NaNkg','NaNL'].includes(s));
    this.qtyPerCase = GetSafeValue.getSafeValueAsList(data['qtyPerCase'], [], []);
    this.color = GetSafeValue.getSafeValueAsList(data['color'], [], []);
    this.type = GetSafeValue.getSafeValueAsList(data['type'], [], []);
    this.condition = GetSafeValue.getSafeValueAsList(data['condition'], [], []);
  }

  static clone(data: VariationOrder) {
    return Object.assign(new VariationOrder(), data);
  }

  get type(): string[] {
    return this._type;
  }

  set type(value: string[]) {
    this._type = value;
  }

  get size(): string[] {
    return this._size;
  }

  set size(value: string[]) {
    this._size = value;
  }

  get qtyPerCase(): string[] {
    return this._qtyPerCase;
  }

  set qtyPerCase(value: string[]) {
    this._qtyPerCase = value;
  }

  get color(): string[] {
    return this._color;
  }

  set color(value: string[]) {
    this._color = value;
  }

  get condition(): string[] {
    return this._condition;
  }

  set condition(value: string[]) {
    this._condition = value;
  }

  toMap() {
    return {
      'size': this.size,
      'qtyPerCase': this.qtyPerCase,
      'color': this.color,
      'type': this.type
    };
  }

  toMapSuggestionVariations() {
    return {
      'size': this.size,
      'qtyPerCase': this.qtyPerCase,
      'condition': this.condition,
      'type': this.type
    };
  }
}
